module.exports = __webpack_public_path__ + "img/side_skype.2053bdb6.png";